import Rows from "PFApp/components/table/rows";
import { EngagementRolesBadge } from "PFComponents/role/engagement_roles_badge";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import PropTypes from "prop-types";
import React, { useCallback } from "react";

import ThreeDotsMenu from "../three_dots_menu";

const EngagementsRows = ({
  items,
  isLoading,
  columns,
  fetchData,
  pinnedIds,
  setPinnedIds,
  selectedIds,
  setSelectedIds,
  markAsRead,
  utmSource,
  onAddCoOwner,
  onEngagementShare
}) => {
  const renderCell = useCallback((item, column) => {
    if (column.name === "roles") {
      return <EngagementRolesBadge engagement={item} />;
    } else if (column.name === "status") {
      return <RoleStatusBadge state={item.state} />;
    }
  }, []);

  const renderActions = (item) => (
    <ThreeDotsMenu
      item={item}
      type="engagement"
      afterRemove={() => fetchData()}
      coowned={item.coowned}
      pinned={pinnedIds}
      setPinned={setPinnedIds}
      addCoOwner={onAddCoOwner}
      share={onEngagementShare}
    />
  );

  return (
    <Rows
      items={items}
      selectedIds={selectedIds}
      pinnedIds={pinnedIds}
      dimUnselectedRows={false}
      setSelectedIds={setSelectedIds}
      columns={columns}
      isLoading={isLoading}
      isSelectMode={true}
      renderCell={renderCell}
      renderActions={renderActions}
      markAsRead={markAsRead}
      utmSource={utmSource}
    />
  );
};

EngagementsRows.propTypes = {
  items: PropTypes.array.isRequired,
  isUnseen: PropTypes.bool,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired })).isRequired,
  fetchData: PropTypes.func,
  pinnedIds: PropTypes.arrayOf(PropTypes.number),
  setPinnedIds: PropTypes.func,
  selectedIds: PropTypes.array,
  setSelectedIds: PropTypes.func,
  markAsRead: PropTypes.func,
  utmSource: PropTypes.string,
  onAddCoOwner: PropTypes.func,
  onEngagementShare: PropTypes.func
};

export default EngagementsRows;
